<div
    class="d-flex preclarification-content align-items-center"
    (click)="toggle()"
    [ngClass]="{ collapsed: isCollapsed, expanded: !isCollapsed }"
>
    <fa-icon
        [icon]="isCollapsed ? faChevronRight : faChevronDown"
        aria-hidden="true"
        class="d-block d-lg-none me-3"
    ></fa-icon>
    <h3 class="m-0">{{ preclarificationLongtextTitle }}</h3>
</div>
@if (!isCollapsed) {
    <div>
        @for (text of preclarificationLongtext; track text) {
            <div class="user-select-auto mt-2" paceCoreLink [innerHTML]="text.TextLine"></div>
        }
    </div>
}
